<template>
  <div class="answer" flex="main:center">
    <xmlNavBack v-if="!$store.getters.isLayout" />
    <div class="answer-page" flex="cross:top">
      <!-- <div class="answer-page--sidebar">
        <div class="dot-title no-border">答题卡</div>

        <div class="count-down" v-if="testPaperDetail.testDuration">
          <span v-if="disabled">考试已结束</span>
          <span v-if="!disabled">考试倒计时：</span>
          <bc-count-down style="color: #ff5353" v-if="!disabled" :end-time="lastTime"
            :callback="endTime"></bc-count-down>
        </div>

        <div class="sidebar-content" style="flex: 1; min-height: 0" flex="dir:top">
          <div class="moduleContent" style="flex: 1; min-height: 0">
            <div v-show="typeOk == 'true'" class="module" v-for="(
module, moduleIndex
              ) in testPaperDetail.testPaperModuleList" :key="module.id">
              <div class="module-name">
                {{ moduleIndex + 1 }}、{{ module.moduleName }}
              </div>

              <div class="module-question" v-if="typeOk == 'true'">
                <div class="question-seq" v-for="(question, questionIndex) in paperList" :key="questionIndex"
                  v-show="question.questionType == module.moduleQuestionType">
                  <div class="question-seq--item" :class="{ isAnswer: question.isAnswer }"
                    @click="toQuestion(moduleIndex, questionIndex, question)">
                    {{ questionIndex - module.testPaperNumber + 1 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="module">
              <div class="module-question" v-if="typeOk != 'true'">
                <div class="question-seq" v-for="(question, questionIndex) in paperList" :key="questionIndex">
                  <div class="question-seq--item" :class="{ isAnswer: question.isAnswer }"
                    @click="toQuestion(moduleIndex, questionIndex, question)">
                    {{ questionIndex + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="padding: 20px 0; border-top: 1px solid #f2f2f2">
            <div flex class="tips">
              <div class="tips-item">
                <div class="status true"></div>
                <div class="text">已做</div>
              </div>
              <div class="tips-item">
                <div class="status false"></div>
                <div class="text">未做</div>
              </div>
            </div>
            <el-button :disabled="disabled" class="submitBtn" @click="submitTestPaper"
              v-if="typeOk == 'true' && !disabled">提交试卷</el-button>
            <el-button class="submitBtn" @click="practicePaper" v-if="typeOk != 'true'">退出练习</el-button>
          </div>
        </div>
      </div> -->

      <div class="answer-page--newsidebar">
        <div class="dot-title-new no-border">答题卡</div>
        <div class="white-back">
          <div style="padding-bottom: 16px ; border-bottom: 1px solid #f2f2f2">
            <div flex class="tips">
              <div class="tips-item" flex="cross:center">
                <div class="status true"></div>
                <div class="text">已做</div>
              </div>

              <div class="tips-item" flex="cross:center">
                <div class="status false"></div>
                <div class="text">未做</div>
              </div>
            </div>


          </div>
          <div class="sidebar-content" style="flex: 1; min-height: 0" flex="dir:top">
            <div class="moduleContent" style="flex: 1; min-height: 0">
              <div class="module" v-for="(module, moduleIndex) in testPaperDetail.testPaperModuleList" :key="module.id">
                <div class="module-name">
                  {{ moduleIndex + 1 }}.{{ module.moduleName }}
                </div>

                <div class="module-question">
                  <div class="question-seq" v-for="(question, questionIndex) in module.questionList"
                    :key="questionIndex">
                    <div class="question-seq--item" :class="{ isAnswer: question.isAnswer }"
                      @click="toQuestion(moduleIndex, questionIndex)">
                      {{ questionIndex + 1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btnList" v-if="answerType == 'practice'">
              <el-button :disabled="disabled" class="practiceBtn" @click="submitPracticePaper" v-if="!disabled">{{
                answerType
                  ==
                  'practice' ? '结束练习' : '提交试卷' }}</el-button>
              <el-button @click="practicePaper" v-if="typeOk == 'false'" class="practiceBtn">暂时退出</el-button>
            </div>
            <el-button :disabled="disabled" class="submitBtn" @click="submitTestPaper"
              v-if="!disabled && answerType != 'practice'">{{ answerType ==
                'practice' ? '结束练习' : '提交试卷' }}</el-button>
          </div>
        </div>
      </div>

      <!-- 单题模式选项 -->
      <div v-if="previewMode == 'paginated'" class="answer-page--main">
        <div class="test-paper">
          <el-scrollbar wrap-class="test-paper-wrap" view-class="test-paper-view">
            <div class="testPaper-title">{{ testPaperDetail.paperName }}
              <div class="testPaper-title-right" v-if="testPaperDetail.testDuration">
                <span v-if="disabled" class="time-text">考试已结束</span>
                <div class="title-time">
                  <div v-if="!disabled" class="time-text">答题用时</div>
                  <div class="time-interval">
                    <div class="interval-item"> {{ hour }}</div>
                    :
                    <div class="interval-item">{{ minute }}</div>
                    :
                    <div class="interval-item">{{ second }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-carousel :height="height" width="800px" :autoplay="false" indicator-position="none"
                :initial-index="oIndex" arrow="never" ref="cardShowx">
                <el-carousel-item v-for="(question, questionIndex) in paperList" :key="questionIndex"
                  class="carousel_item">
                  <div class="answer_overflow">
                    <bc-answer-question :dict="{ label: dict.label }"
                      :class="`answer-module-${moduleIndex}--question-${current}`" :question="question"
                      :seq="questionIndex + 1" :key="questionIndex" :typeOk="typeOk" :aishow="isShowAi
                        ? 'true'
                        : 'false'
                        " @change="changeAnswerv2(questionIndex, $event)"
                      @changeCancel="changeCancel(questionIndex, $event)" @openAi="openAi"
                      :isView="{ isViewAnswer: 0, isViewStatistics: 1 }" :answerType="answerType"></bc-answer-question>
                  </div>
                  <div class="answerBut">
                    <el-button type="primary" style="width: 128px" :disabled="questionIndex == 0"
                      @click="prevs(questionIndex)" class="preventBtn">上一题</el-button>
                    <el-button v-if="!question.isAnswer && typeOk == 'false'" type="primary" style="width: 128px"
                      @click="cancels(question, questionIndex)">选好了</el-button>
                    <el-button type="primary" style="width: 128px" :disabled="questionIndex == paperList.length - 1"
                      @click="nexts()">下一题</el-button>
                    <el-button type="primary" style="width: 128px" @click="submitTestPaper" v-if="typeOk == 'false' &&
                      questionIndex == paperList.length - 1 &&
                      question.isAnswer
                    ">结束练习</el-button>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <!-- 多题模式选项 -->
      <div class="answer-page--main" flex="dir:top" v-if="previewMode == 'scrolled'">
        <div class="testPaper-title" style="padding: 21px 30px;">{{ testPaperDetail.paperName }}
          <div class="testPaper-title-right" v-if="testPaperDetail.testDuration">
            <span v-if="disabled" class="time-text">考试已结束</span>
            <div class="title-time">
              <div v-if="!disabled" class="time-text">答题用时</div>
              <div class="time-interval">
                <div class="interval-item"> {{ hour }}</div>
                :
                <div class="interval-item">{{ minute }}</div>
                :
                <div class="interval-item">{{ second }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="test-paper">
          <el-scrollbar style="height: 100%" wrap-class="test-paper-wrap" view-class="test-paper-view">
            <div class="scrool_ybox">
              <div v-for="(question, questionIndex) in paperList" :key="questionIndex"
                :id="`bc-answer-question ${questionIndex}`">
                <bc-answer-question :dict="{ label: dict.label }"
                  :class="`answer-module-${moduleIndex}--question-${questionIndex}`" :question="question"
                  :seq="questionIndex + 1" :key="questionIndex" :typeOk="typeOk" :aishow="isShowAi
                    ? 'true'
                    : 'false'
                    " @change="changeAnswerv2(questionIndex, $event)"
                  @changeCancel="changeCancel(questionIndex, $event)" @openAi="openAi"
                  :isView="{ isViewAnswer: 0, isViewStatistics: 1 }" :answerType="answerType"></bc-answer-question>
                <div class="answerBut" v-if="typeOk == 'false'">
                  <el-button v-if="!question.isAnswer" type="primary" style="width: 128px"
                    @click="cancels(question, questionIndex)">选好了</el-button>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <robot style="z-index: 9999" v-if="isShowAi" ref="robotBox" :goodsId="goodsId" :bookName="bookdetail" />
  </div>
</template>
<script>
import robot from "@/components/robot.vue";
import { robotBook } from "@/utils/config.js";
import XEUtils from "xe-utils";
import { paperGetToken } from "@/api/index/index";
import xmlNavBack from '../components/xmlNavBack.vue'
import { goodsInfoDetail } from "@/api/bookstore/bookstore";

import {
  getTestPaperApi,
  CreateAnswerPaperRecord,
  submitAnswerPaperRecord,
  addAnswerapi,
  getUnSubmitPaperRecord,
  addWrongQuestion,
} from "@/api/answer/answer";
import { MessageBox } from "element-ui";
export default {
  components: {
    robot, xmlNavBack
  },
  dicts: ["difficulty", "question_type"],
  data() {
    return {
      readtype: "", //阅读类型
      bookdetail: "建筑构造",
      goodsId: "",
      robotBook: "",
      moduleIndex: 0,
      showAi: false,
      loading: false,
      testPaperId: "",
      answerPlatform: "out",
      aprId: "",
      disabled: false,
      testPaperDetail: {},
      lastTime: 0,
      current: 0,
      testPaperRecord: {},
      previewMode: "scrolled", //paginated scrolled
      oIndex: 0,
      answerType: "",
      selectArr: {},
      synArrmoduleIndex: 0,
      synquestionIndex: 0,
      questionId: "",
      answerResults: "",
      typeOk: "other", //false自测和true练习 其他other
      paperList: [],
      questionGrouplist: "",
      answerQuestionRecordList: [],
      testPaperNumber: 0,
      _beforeUnload_time: 0,
      _gap_time: 0,
      height: "",
      paperGenerateMethod: "",
      hour: "",
      minute: "",
      second: "",
      show: false,
    };
  },
  computed: {
    isShowAi() {
      if (this.robotBook.includes(this.goodsId) && this.typeOk == 'false') {
        return true
      }
      if (this.$store.getters.threePlatform == 'xueKeKnowledgeBaseSys' && this.typeOk == 'false') {
        return true
      }
      if (this.show && this.answerType == 'practice') {
        return true
      }
      return false
    }
  },
  created() {
    this.robotBook = robotBook;
    this.height = window.innerHeight - 210 + "px";
    this.previewMode = this.$route.query.previewMode;
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.addEventListener("unload", (e) => this.unloadHandler(e));
    this.goodsId = this.$route.query.goodsId;
    this.bookdetail = this.$route.query.bookName;
    this.testPaperId = this.$route.query.paperId;
    this.typeOk = this.$route.query.typeOk; //自测练习
    this.answerType = this.$route.query.answerType;
    this.paperGenerateMethod = this.$route.query.paperGenerateMethod || "";

    if (this.testPaperId) {
      //创建
      console.log("创建新答题");
      this.createAnswerPaper();
    } else {
      //历史
      console.log("历史答题");
      this.continueAnsweringQuestions();
    }
    this.fixShowAi(this.goodsId)
  },
  destroyed() {
    // 关闭浏览器执行退出接口
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
  methods: {
    fixShowAi(id) {
      goodsInfoDetail(id).then((res) => {
        if (res.code == 200 && res.data.xiaoZhi) {
          this.show = true
        }
        else {
          this.show = false
        }
      })
    },
    countDown(timestamp) {
      this.timer = setInterval(() => {
        let nowTime = new Date()
        let endTime = new Date(timestamp)
        let t = endTime.getTime() - nowTime.getTime()
        if (t > 0) {
          let day = Math.floor(t / 86400000)
          let hour = Math.floor((t / 3600000) % 24)
          let min = Math.floor((t / 60000) % 60)
          let sec = Math.floor((t / 1000) % 60)
          this.hour = hour < 10 ? '0' + hour : hour
          this.minute = min < 10 ? '0' + min : min
          this.second = sec < 10 ? '0' + sec : sec

        } else {
          clearInterval(this.timer)
          this.requestSubmit()
        }
      }, 1000)
    },
    openAi(e) {
      console.log('aaaaaaaaaaaaaaaaaaa');
      var dataAi = e.replace(/<[^>]+>/g, "");
      this.$refs.robotBox.robotShwo = true;
      this.$refs.robotBox.sending(dataAi);
    },
    beforeunloadHandler(e) {
      this._beforeUnload_time = new Date().getTime();
      e = e || window.event;
      if (e) {
        if (this.typeOk == "true") {
          paperGetToken().then((token) => {
            let params = {
              paperId: this.testPaperId,
              answerPlatform: this.answerPlatform,
              id: this.aprId,
              userId: this.$store.getters.userId,
              userName: this.$store.getters.name,
              params1: this.goodsId,
              params2: this.paperGenerateMethod,
              testDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
              token: token.data,
            };
            submitAnswerPaperRecord(params);
          });
        }
      }
      return;
    },
    unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      debugger;
      //判断是窗口关闭还是刷新
      console.log(this._gap_time);
      debugger;
    },
    // 新增考试记录
    createAnswerPaper() {
      paperGetToken().then((token) => {
        CreateAnswerPaperRecord({
          userId: this.$store.getters.userId,
          paperId: this.testPaperId,
          userName: this.$store.getters.name,
          testDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          answerPlatform: "out",
          token: token.data,
        }).then((res) => {
          this.aprId = res.msg;
          this.getTestPaperDetail();
        });
      });
    },
    // 继续答题
    continueAnsweringQuestions() {
      paperGetToken().then((token) => {
        getUnSubmitPaperRecord({
          answerPlatform: "out",
          paperId: "",
          userId: this.$store.getters.userId,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          token: token.data,
        }).then((res) => {
          if (res.code == 200) {
            let answeredQuantity = 0
            this.testPaperDetail = res.data.tTestPaperDetailInfoVo;
            this.aprId = res.data.answerQuestionRecordList[0].aprId;
            if (res.data.tTestPaperDetailInfoVo.testPaperModuleList) {
              this.testPaperId =
                res.data.tTestPaperDetailInfoVo.testPaperModuleList[0].paperId;
              res.data.tTestPaperDetailInfoVo.testPaperModuleList.map(
                (item) => {
                  this.paperList = this.paperList.concat(item.questionList);
                  // console.log("this.paperList", this.paperList);
                }
              );
              this.answerQuestionRecordList = res.data.answerQuestionRecordList;
              this.paperList.map((item, index) => {
                let isGroup = false
                this.$set(item, "isAnswer", false); //回答是否正确
                let paperIndex = this.answerQuestionRecordList.filter(
                  (value) => {
                    if (value.questionGroupId) {
                      isGroup = true
                      return item.id == value.questionGroupId;
                    } else {
                      return item.id == value.questionId;
                    }
                  }
                );
                console.log("paperIndex", paperIndex);

                //返回多个为题组  一个为普通试题
                if (paperIndex.length == 1 && !isGroup) {
                  // 判断保存
                  if (paperIndex[0].answerResults) {
                    answeredQuantity++
                    this.$set(
                      this.paperList[index],
                      "standardAnswer",
                      item.standardAnswer
                    );
                    this.$set(this.paperList[index], "selectAnswer", true);
                    this.$set(this.paperList[index], "isAnswer", true);
                    this.$set(
                      this.paperList[index],
                      "isAnswerResults",
                      paperIndex[0].answerResults
                    );
                  }
                } else {
                  answeredQuantity++
                  // 题组类型继续答题回显
                  console.log("paperIndexpaperIndex", paperIndex);
                  console.log("paperList", this.paperList);
                  paperIndex.map((items) => {
                    // 乱序的时候选项也是乱序先找的对应的index
                    let lxindex = this.paperList[index].questionList.findIndex(
                      (item) => {
                        return item.id == items.questionId;
                      }
                    );
                    console.log("lxindex", lxindex);
                    if (items.answerResults) {
                      this.$set(this.paperList[index], "isAnswer", true);
                      // 用户答案
                      this.$set(
                        this.paperList[index].questionList[lxindex],
                        "isAnswerResults",
                        items.answerResults
                      );
                      // 标准答案
                      this.$set(
                        this.paperList[index].questionList[lxindex],
                        "standardAnswer",
                        item.questionList[lxindex].standardAnswer
                      );
                      this.$set(
                        this.paperList[index].questionList[lxindex],
                        "selectAnswer",
                        true
                      );
                      // 是否作答
                      this.$set(
                        this.paperList[index].questionList[lxindex],
                        "isAnswer",
                        true
                      );
                    }
                  });
                }
              });
              // // 根据是否作答排序
              // this.paperList = this.paperList.sort(
              //   (a, b) => b.isAnswer - a.isAnswer
              // );

              if (this.answerType == 'practice') {
                setTimeout(() => {
                  this.toQuestion(0, answeredQuantity)
                }, 1000);
              }

              console.log("this.paperList2", this.paperList);
            }
          }
        });
      });
    },

    //跳转
    toQuestion(e, index) {
      if (this.previewMode == "scrolled") {
        let i = e + index
        var target = document.getElementById(`bc-answer-question ${i}`);
        target.parentNode.scrollTop = target.offsetTop;
      }
      this.moduleIndex = e;
      this.questionIndex = index;
      console.log("e", e, index);

      if (this.$refs.cardShowx) {
        let questionsBeforeCurrentModule = this.getQuestionsCountBeforeModule(e);
        let i = questionsBeforeCurrentModule + index;
        this.$refs.cardShowx.setActiveItem(i);
      }

    },
    // 计算实际的题号
    getQuestionsCountBeforeModule(e) {
      if (e <= 0) return 0;

      let total = 0;
      for (let i = 0; i < e && i < this.testPaperDetail.testPaperModuleList.length; i++) {
        total += this.testPaperDetail.testPaperModuleList[i].questionList
          ? this.testPaperDetail.testPaperModuleList[i].questionList.length
          : 0;
      }
      return total;
    },
    // 下一题
    nexts(e) {
      this.$refs.cardShowx.next();
    },
    // 上一题
    prevs() {
      this.$refs.cardShowx.prev();
    },
    //保存历史进度
    practicePaper() {
      // window.close();
      this.$router.back()
    },
    //题组回显
    changeCancel(questionIndex, val) {
      console.log(questionIndex, val);
      let answerResults = val.value;
      if (!answerResults) return;
      if (val.questionIndex || val.questionIndex === 0) {
        console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
        answerResults = val.value.value;
        let questionGroup = this.paperList[questionIndex]["questionList"];
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswer",
          !!answerResults
        );
        let questionGroupAll = questionGroup.every((i) => i.isAnswer);
        this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
      }
      paperGetToken().then((token) => {
        //保存进度
        let params = {
          questionId:
            this.paperList[questionIndex].questionList[val.questionIndex].id,
          answerPlatform: this.answerPlatform,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.userName,
          paperId: this.testPaperId,
          answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          answerResults:
            this.paperList[questionIndex].questionList[val.questionIndex]
              .isAnswerResults.value,
          aprId: this.aprId,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          token: token.data,
        };
        addAnswerapi(params).then((res) => {
          if (this.typeOk == "false") {
            if (res.data.answerQuestionRecord.answerSituation == 0) {
              this.addErrorBook();
            }
            this.$set(
              this.paperList[questionIndex]["questionList"][val.questionIndex],
              "standardAnswer",
              res.data.standardAnswer
            );
            this.$set(
              this.paperList[questionIndex]["questionList"][val.questionIndex],
              "selectAnswer",
              true
            );
          }
        });
      });
    },
    //选好了回显
    cancels(item, index) {
      console.log("this.paperList", this.paperList);
      let val = this.questionGrouplist;
      let questionIndex = index;
      let answerResults = item.isAnswerResults;
      console.log(item);
      if (!answerResults) return;
      if (val.questionIndex || val.questionIndex === 0) {
        console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
        answerResults = val.value.value;
        let questionGroup = this.paperList[questionIndex]["questionList"];
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswer",
          !!answerResults
        );
        let questionGroupAll = questionGroup.every((i) => i.isAnswer);
        this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
      } else {
        this.$set(this.paperList[questionIndex], "isAnswer", !!answerResults);
        paperGetToken().then((token) => {
          //保存进度
          let params = {
            questionId: item.id,
            answerPlatform: this.answerPlatform,
            userId: this.$store.getters.userId,
            userName: this.$store.getters.userName,
            paperId: this.testPaperId,
            answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
            answerResults: this.paperList[index].isAnswerResults,
            aprId: this.aprId,
            params1: this.goodsId,
            params2: this.paperGenerateMethod,
            token: token.data,
          };
          addAnswerapi(params).then((res) => {
            console.log("答题", res);
            if (this.typeOk == "false" || this.typeOk == "other") {
              if (res.data.answerQuestionRecord.answerSituation == 0) {
                this.addErrorBook();
              }
              this.$set(
                this.paperList[index],
                "standardAnswer",
                res.data.standardAnswer
              );
              this.$set(
                this.paperList[index],
                "astatistics",
                res.data.astatistics
              );
              this.$set(this.paperList[index], "selectAnswer", true);
            }
          });
        });
      }
    },
    async changeAnswer(moduleIndex, questionIndex, val) {
      console.log(val);

      let questionId = val.questionId;
      let answerResults = val.value;
      if (val.questionIndex || val.questionIndex === 0) {
        console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
        questionId = val.value.questionId;
        answerResults = val.value.value;
        let questionGroup =
          this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
          questionIndex
          ]["questionList"];
        this.$set(
          this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
          questionIndex
          ]["questionList"][val.questionIndex],
          "isAnswer",
          !!answerResults
        );

        let questionGroupAll = questionGroup.every((i) => i.isAnswer);
        this.$set(
          this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
          questionIndex
          ],
          "isAnswer",
          questionGroupAll
        );
      } else {
        this.$set(
          this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
          questionIndex
          ],
          "isAnswer",
          !!answerResults
        );
      }

      console.log(
        `模块${moduleIndex}-第${questionIndex}题-回答的是：${answerResults}`
      );

      paperGetToken().then((token) => {
        //保存进度
        let params = {
          questionId,
          answerPlatform: this.answerPlatform,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.userName,
          paperId: this.testPaperId,
          answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          answerResults,
          aprId: this.aprId,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          token: token.data,
        };
        addAnswerapi(params).then((res) => {
          if (this.typeOk == "false") {
            if (res.data.answerQuestionRecord.answerSituation == 0) {
              this.addErrorBook();
            }
          }
        });
      });
    },
    //添加错题本
    addErrorBook() {
      paperGetToken().then((token) => {
        localStorage.setItem('paperToken', token.data)
        addWrongQuestion({
          questionId: this.paperList[this.synquestionIndex].id,
          answerPlatform: "out",
          userId: this.$store.getters.userId,
          paperId: this.testPaperId,
          aprId: this.aprId,
          goodId: this.goodsId,
        });
      });
    },

    // 获取考试试卷详情
    getTestPaperDetail() {
      paperGetToken().then((token) => {
        getTestPaperApi(
          {
            paperId: this.testPaperId,
            ansRecordId: this.aprId,
          },
          token.data
        ).then((res) => {
          this.testPaperDetail = res.data;
          console.log("testPaperDetail", this.testPaperDetail);
          //paginated scrolled
          res.data.testPaperModuleList.map((item) => {
            this.$set(item, "testPaperNumber", this.testPaperNumber);
            this.testPaperNumber += item.questionList.length;
            this.paperList = this.paperList.concat(item.questionList);
          });
          this.paperList.map((item) => {
            this.$set(item, "isAnswer", false); //回答是否正确
          });
          if (this.testPaperDetail.testDuration) {
            let date = new Date();
            let min = date.getMinutes();
            date.setMinutes(min + this.testPaperDetail.testDuration);
            this.lastTime = date.getTime();
            this.countDown(this.lastTime)
          }
        });
      });
    },
    //提交试卷
    async submitTestPaper() {
      if (this.testPaperDetail.testDuration) {
        this.$confirm("考试时间还未结束，是否提前交卷？", "提示")
          .then(async (res) => {
            if (res === "confirm") {
              this.requestSubmit();
            }
          })
          .catch(() => { });
      } else {
        let isAnswer = "";
        let arr = this.testPaperDetail.testPaperModuleList;
        arr.forEach((item) => {
          item.questionList.forEach((i) => {
            if (i.isAnswer) {
              isAnswer = "是否交卷？";
            } else {
              isAnswer = "是否交卷？";
              return;
            }
          });
        });
        this.$confirm(isAnswer, "提示")
          .then(async (res) => {
            if (res === "confirm") {
              this.requestSubmit();
            }
          })
          .catch(() => { });
      }
    },
    // 练习退出
    submitPracticePaper() {
      let isAnswer = "";
      let arr = this.testPaperDetail.testPaperModuleList;
      arr.forEach((item) => {
        item.questionList.forEach((i) => {
          if (i.isAnswer) {
            isAnswer = "是否结束练习？";
          } else {
            isAnswer = "是否结束练习？";
            return;
          }
        });
      });
      this.$confirm(isAnswer, "提示")
        .then(async (res) => {
          if (res === "confirm") {
            this.PracticeSubmit();
          }
        })
        .catch(() => { });
    },
      //提交试卷
    async PracticeSubmit() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      paperGetToken().then((token) => {
        let params = {
          paperId: this.testPaperId,
          answerPlatform: this.answerPlatform,
          id: this.aprId,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.name,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          testDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          token: token.data,
        };
        submitAnswerPaperRecord(params).then((res) => {
          loading.close();
          if (res.code === 200) {
            // this.$message.success("交卷成功");
            this.disabled = true;
            this.$router.back();
            // this.$router.replace({
            //   path: "/bookstore/answerRecord",
            //   query: {
            //     ansRecordId: this.aprId,
            //     paperId: this.testPaperId,
            //     showAi: this.showAi,
            //     questionNum: this.paperList.length,
            //     goodsId: this.goodsId,
            //     bookdetail: this.bookdetail,
            //   },
            // });
          }
        });
      });
    },
    //结束
    endTime() {
      MessageBox.confirm("考试时间已结束，正在交卷", "提示", {
        closeOnClickModal: false,
        showClose: false,
        showCancelButton: false,
        closeOnPressEscape: false,
        showConfirmButton: false,
      }).then((res) => {
        if (res === "confirm") {
          this.requestSubmit();
        }
      });
      setTimeout(() => {
        MessageBox.close();
        this.requestSubmit();
      }, 2000);
    },
    //选择的回调
    async changeAnswerv2(questionIndex, val) {
      //回显模块的
      console.log(questionIndex, val);
      this.synquestionIndex = questionIndex; //位置
      this.questionGrouplist = val; //选择的数据
      //选择的答案
      let questionId = val.questionId;
      let answerResults = val.value;
      if (val.questionIndex || val.questionIndex === 0) {
        this.$set(
          this.paperList[questionIndex]["questionList"][val.questionIndex],
          "isAnswerResults",
          answerResults
        );
      } else {
        this.$set(
          this.paperList[questionIndex],
          "isAnswerResults",
          answerResults
        );
      }
      //自测
      if (this.typeOk == "true") {
        let val = this.questionGrouplist;
        let questionIndex = this.synquestionIndex;
        let answerResults = val.value;
        if (!answerResults) return;
        if (val.questionIndex || val.questionIndex === 0) {
          console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
          answerResults = val.value.value;
          questionId = val.value.questionId;
          let questionGroup = this.paperList[questionIndex]["questionList"];
          //判断选择已答未答
          this.$set(
            this.paperList[questionIndex]["questionList"][val.questionIndex],
            "GroupIsAnswer",
            !!answerResults
          );
          let questionGroupAll = questionGroup.every((i) => i.GroupIsAnswer);
          this.$set(
            this.paperList[questionIndex],
            "isAnswer",
            questionGroupAll
          );
          this.addAnswerapix(questionId, answerResults);
        } else {
          this.$set(this.paperList[questionIndex], "isAnswer", !!answerResults);
          this.addAnswerapix(questionId, answerResults);
        }
      }
    },
    //保存答题
    addAnswerapix(questionId, answerResults) {
      paperGetToken().then((token) => {
        //保存进度
        let params = {
          questionId: questionId,
          answerPlatform: this.answerPlatform,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.userName,
          paperId: this.testPaperId,
          answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          answerResults: answerResults,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          aprId: this.aprId,
          token: token.data,
        };
        addAnswerapi(params).then((res) => { });
      });
    },
    //提交试卷
    async requestSubmit() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      paperGetToken().then((token) => {
        let params = {
          paperId: this.testPaperId,
          answerPlatform: this.answerPlatform,
          id: this.aprId,
          userId: this.$store.getters.userId,
          userName: this.$store.getters.name,
          params1: this.goodsId,
          params2: this.paperGenerateMethod,
          testDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
          token: token.data,
        };
        submitAnswerPaperRecord(params).then((res) => {
          loading.close();
          if (res.code === 200) {
            this.$message.success("交卷成功");
            this.disabled = true;
            this.$router.replace({
              path: "/bookstore/answerRecord",
              query: {
                ansRecordId: this.aprId,
                paperId: this.testPaperId,
                showAi: this.showAi,
                questionNum: this.paperList.length,
                goodsId: this.goodsId,
                bookdetail: this.bookdetail,
              },
            });
          }
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.answer {
  width: 1400px;
  height: 100%;
  // background: #f2f2f2;
  margin: 0 auto;

  .testPaper-title {
    text-align: center;
    padding: 21px 0;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 600;
    font-size: 20px;
    color: #27272A;
    line-height: 24px;

    .testPaper-title-right {
      float: right;
      display: flex;
      align-items: center;

      .time-text {
        font-family: Microsoft Sans Serif, Microsoft Sans Serif;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        margin-right: 6px;
      }

      .title-time {
        display: flex;
        align-items: center;

        .time-interval {
          display: flex;
          align-items: center;
          // background: #33649F;
          color: #33649F;

          .interval-item {
            color: #33649F;
            font-size: 14px;
            line-height: 22px;
            background: #E3F0FF;
            border-radius: 2px;
            padding: 2px;
            margin: 0 6px;
          }

          .interval-item :last-child {
            margin-right: 0;
          }

          .interval-item :first-child {
            margin-left: 0;
          }
        }
      }
    }
  }

  .answer-page {
    display: flex;
    padding-bottom: 20px;

    .answer-page--sidebar {
      width: 304px;
      background: #fffefd;
      border-radius: 6px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .count-down {
        padding: 10px 20px 0;
      }

      .sidebar-content {
        .moduleContent {
          padding-bottom: 20px;
          flex: 1;
          height: calc(100vh - 340px);
          overflow-y: scroll;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .module {
            padding: 20px 20px 10px;

            &+.module {
              border-top: 1px solid #f2f2f2;
            }

            .module-name {
              font-size: 14px;
              color: #333333;
              margin-bottom: 15px;
            }

            .module-question {
              margin-left: -5px;
              margin-right: -5px;

              &::after,
              &::before {
                display: table;
                content: "";
              }

              &::after {
                clear: both;
              }

              .question-seq {
                padding-left: 6px;
                padding-right: 5px;
                float: left;
                margin-bottom: 10px;

                .question-seq--item {
                  width: 30px;
                  height: 21px;
                  line-height: 24px;
                  text-align: center;
                  background: #ffffff;
                  border: 1px solid #2e9adb;
                  //border-radius: 6px;
                  font-size: 14px;
                  color: #333333;
                  user-select: none;
                  cursor: pointer;
                  transition: all ease 0.3s;

                  &.isAnswer {
                    background: #2e9adb;
                    color: #fff;
                  }
                }
              }
            }
          }
        }

        .btnList {
          display: flex;

          .practiceBtn {
            width: 40%;
            background: #2e9adb;
            text-align: center;
            color: #fff;
            display: block;
            margin-top: 12px;
            background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
            box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
            border-radius: 12px;
          }
        }
      }
    }

    .answer-page--main {
      width: 1080px;
      // height: calc(100vh - 150px);
      background: #fffefd;
      border-radius: 6px;
      overflow: hidden;
      flex-direction: column;

      .test-paper {
        flex: 1;
        min-height: 0;

        ::v-deep .test-paper-wrap {
          overflow-x: hidden;
        }

        ::v-deep .test-paper-view {
          padding: 0 30px;
        }

        .paper-module {
          &+.paper-module {
            margin-top: 20px;
          }

          .paper-module--name {
            // margin-bottom: 24px;
          }
        }
      }
    }

    .answer-page--newsidebar {
      width: 304px;
      // background: #BEDBFE;
      background: #FFFFFF;
      border-radius: 12px;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

      // border: 1px solid;
      // border-image: linear-gradient(180deg, rgba(40, 124, 247, 1) 20%, rgba(255, 255, 255, 1)) 1 1;

      .dot-title-new {
        padding: 13px 16px;
        background: #BEDBFE;
        border-radius: 12px 12px 0 0;
      }

      .white-back {
        width: 100%;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        position: relative;
        padding: 16px;

        // border: 1px solid #BEDBFE;
        .border {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          width: 100%;
          height: 64px;
          border: 1px solid;
          border-top: none;
          border-image: linear-gradient(180deg, #5F9BF4, rgba(255, 255, 255, 1)) 1 1;
        }
      }

      .count-down {
        background: linear-gradient(180deg, #F2F7FF 0%, #F8FAFC 100%);
        border-radius: 0px 0px 0px 0px;
        padding-top: 32px;
        padding-bottom: 26px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

        .time-text {
          font-family: DingTalk JinBuTi, DingTalk JinBuTi;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #27272A;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;
          z-index: 12;
        }

        // .text-back {
        //   width: 107px;
        //   height: 24px;
        //   margin-top: -14px;
        //   background-image: url(../../assets/images/time-text.png);
        //   background-position: center center;
        //   background-size: 107px 24px;
        //   background-repeat: no-repeat;
        //   position: relative;
        //   z-index: 10;
        // }

        // .time-back {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   width: 54px;
        //   height: 54px;
        //   background-image: url(../../assets/images/answer-back.png);
        //   background-position: 0 0;
        //   background-size: 54px 54px;
        //   background-repeat: no-repeat;
        // }
      }

      .sidebar-content {
        .moduleContent {
          // padding-bottom: 20px;
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          overflow-x: hidden;
          max-height: 390px;
          border-bottom: 1px solid #F4F4F5;

          &::-webkit-scrollbar,
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          // 滚动条样式1
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 3px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          // 滚动条样式2
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #dcdee2;
          }

          .module {
            padding: 8px 0px 10px;

            &+.module {
              // border-top: 1px solid #f2f2f2;
            }

            .module-name {
              font-size: 14px;
              padding: 8px;
              font-family: Microsoft YaHei UI, Microsoft YaHei UI;
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
              color: #27272A;
              text-align: left;
              font-style: normal;
              text-transform: none;
              color: #333333;
              margin-bottom: 16px;
              background: #FCFCFC;
              border-radius: 4px 4px 4px 4px;
            }

            .module-question {
              margin-left: -5px;
              margin-right: -5px;

              &::after,
              &::before {
                display: table;
                content: "";
              }

              &::after {
                clear: both;
              }

              .question-seq {
                padding-left: 6px;
                padding-right: 5px;
                float: left;
                margin-bottom: 10px;

                .question-seq--item {
                  width: 32px;
                  height: 32px;
                  line-height: 19px;
                  text-align: center;
                  background: #F4F4F5;
                  border-radius: 4px 4px 4px 4px;
                  user-select: none;
                  cursor: pointer;
                  transition: all ease 0.3s;
                  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
                  font-weight: 400;
                  font-size: 14px;
                  color: #52525B;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &.isAnswer {
                    background: #287CF7;
                    color: #fff;
                  }
                }
              }
            }
          }
        }

        .btnList {
          display: flex;
          justify-content: space-between;

          .practiceBtn {
            width: 48%;
            background: #2e9adb;
            text-align: center;
            color: #fff;
            display: block;
            margin-top: 12px;
            background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
            box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
            border-radius: 12px;
          }
        }
      }
    }

  }
}

.submitBtn {
  width: 100%;
  background: #2e9adb;
  text-align: center;
  color: #fff;
  display: block;
  margin-top: 12px;
  background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}

.tips {
  // padding: 0px 20px 0px;
  // margin-bottom: 10px;
  display: flex;

  .tips-item {
    display: flex;
    align-items: center;

    &:last-child {
      margin-left: 24px;
    }

    .status {
      width: 12px;
      height: 12px;
      // border: 1px solid #999999;
      border-radius: 50%;

      &.true {
        background: #287CF7;
        border-color: #287CF7;
      }

      &.false {
        background: #A1A1AA;
      }
    }

    .text {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #4E5969;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 6px;
    }
  }
}

::v-deep .question {
  height: auto;

  .questionGroupContent {
    display: block;

    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: inline;

      .stem-content {
        display: inline;

        .text-break-all {
          display: inline;

          p {
            //display: inline;
          }
        }
      }
    }
  }

  .group-content {
    display: inline;

    .question {
      padding-left: 20px;
    }
  }

  .stem {
    .stem-box {
      display: block;

      .questionType {
        display: inline-block;
      }

      .questionSeq,
      .questionScore {
        display: inline-block;
      }

      .content {
        display: inline;

        .stem-content {
          display: inline;

          .text-break-all {
            display: inline;

            p {
              //display: inline;
            }
          }
        }
      }
    }
  }

  .option-item {
    .questionType {
      display: inline-block;
    }

    .questionSeq,
    .questionScore {
      display: inline-block;
    }

    .content {
      display: block;

      .stem-content {
        display: block;

        .text-break-all {
          display: block;

          p {
            display: block;
          }
        }
      }
    }
  }
}

.dot-title {
  text-align: center;
  margin: 10px 0;
}

::v-deep .answerBut {
  width: 500px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 20px;

  .el-button {
    border-radius: 12px;
    background: linear-gradient(270deg, #00C6FF 0%, #0072FF 100%);
  }

  .preventBtn {
    background: #fff;
    color: #287CF7;
  }
}

.button_row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}

.answer_overflow {
  height: calc(100vh - 300px);
  overflow-y: scroll;
}

.carousel_item {
  width: 900px;
}

.carousel_box {
  width: 1000px;
}

.scrool_ybox {
  overflow-x: auto;
  height: 780px;
  margin-bottom: 10px;
}
</style>
